import { render, staticRenderFns } from "./SubmitQuerylogsForm.vue?vue&type=template&id=3a7207f9&"
import script from "./SubmitQuerylogsForm.vue?vue&type=script&lang=js&"
export * from "./SubmitQuerylogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports